import React, { useEffect, useState } from 'react';
const { defaultConfig: { PLATFORM, LOCATION } } = require(`../../../../../../../config/default`);
const { DecisionPopup } = require(`../../../../../../../components/${PLATFORM}/atoms/decision-popup`);
const { STRINGS } = require(`../../../../../../../shared/${PLATFORM}/constants/${LOCATION}/strings`)
const { SnackbarWrapper } = require(`../../../../../../../components/${PLATFORM}/molecules/snackbar-wrapper`);
const { BOOKING_STATUS } = require(`../../../../../../../shared/${PLATFORM}/constants`)

export const Screen = ({
    setPopCancelTrip,
    popupCancelTrip,
    cancelTripByDriver,
    upcomingActiveRowData,
    getDriverTrips,
    getCancelledTrips,
    tripIndex,
    getDriverUpcomingTripList,
    tableIndex,
    tableCellClick
}) => {
    const [snackbarData, setSnackBarData] = useState({
        variant: '',
        message: ''
    });
    const [openSnackBar, setOpenSnackbar] = useState(false);
    const [tripData, setTripData] = useState({});
    const [within24HOUR, setWithin24HOUR] = useState(null);
    var startDate = new Date();
    var endDate

    const updateTable = () => {
        let postData
        // console.log(getDriverUpcomingTripList)
        postData = { limit: 5, index: 0 }
        tableIndex({ ...tripIndex, upcoming: 0 })

        let upcomingTripReq = Object.keys(postData)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(postData[k])
            ).join('&');
        getDriverTrips(upcomingTripReq, (response) => {

        }, (error) => { })

        getCancelledTrips(upcomingTripReq, (response) => {

        }, (error) => { })
    }
    useEffect(() => {
        setTripData(tableCellClick)

        endDate = getDriverUpcomingTripList && getDriverUpcomingTripList.trips.find(x => x.bookingId === tableCellClick.id).pickupTime.to
        let timeString = combineDateAndTime(new Date(tableCellClick.pickupdate), new Date(endDate))

        var seconds = (new Date(timeString).getTime() - startDate.getTime()) / 1000;

        setWithin24HOUR(seconds)
    }, [tableCellClick])


   const combineDateAndTime = function(date, time) {
       let timeString = time.getHours() + ':' + time.getMinutes() + ':00';
    
        var year = date.getFullYear();
        var month = date.getMonth() + 1; // Jan is 0, dec is 11
        var day = date.getDate();
        var dateString = '' + year + '-' + month + '-' + day;
        var combined = new Date(dateString + ' ' + timeString);
    
        return combined;
    };

    useEffect(() => {

    },[within24HOUR])
    
    return (
        <>
        <SnackbarWrapper
            visible={openSnackBar}
            onClose={() => setOpenSnackbar(false)}
            variant={snackbarData.variant}
            message={snackbarData.message}
        />
        <DecisionPopup
            modalVisibility={popupCancelTrip}
            dialogContent={BOOKING_STATUS.BOOKED == tripData.status ?<p>{STRINGS.CANCEL_TRIP_NOTIFICATION}<br />{'Please note that you will be charged' + (within24HOUR <= 86400 ? ' NZD150 ': ' NZD30 ') +'for cancellation of this trip.'}</p> : STRINGS.CANCEL_TRIP_NOTIFICATION}
            dialogTitle={STRINGS.CANCEL_TRIP_CONTENT}
            confirmButtonTitle={STRINGS.CONFIRM}
            rejectButtonTitle={STRINGS.CANCEL}
            toggleDialogModal={() => setPopCancelTrip(!popupCancelTrip)}
            onConfirmation={() => {
                let postData = { id: upcomingActiveRowData._id, status: { status: 4 } }
                cancelTripByDriver(postData, (response) => {
                    setSnackBarData({
                        variant: response.status ? 'success' : 'error',
                        message: 'Trip Cancelled Successfully'
                    });
                    setOpenSnackbar(true)
                    setTimeout(() => {
                        setPopCancelTrip(false)
                        updateTable()
                    }, 1500);
                },
                    (error) => {
                        setSnackBarData({
                            variant: error.status ? 'success' : 'error',
                            message: error.msg
                        });
                        setOpenSnackbar(true)
                        setTimeout(() => {
                            setPopCancelTrip(false)
                        }, 1500);
                    }
                );
            }}
            onRejection={() => setPopCancelTrip(false)} />

        </>
    )
}